/**
 * Onboarding-screen content (PURE MODULE — no Supabase imports).
 *
 * The 4-slide carousel reads from this module so:
 *   1. Unit tests can pin the verbatim HIPAA / 1.4.1 / 5.1.2(i)
 *      language against PRD source text.
 *   2. A future content audit can rewrite copy without touching
 *      the screen component.
 *
 * HIPAA_DISCLAIMER + APPLE_GUIDELINE_1_4_1_DISCLAIMER +
 * THIRD_PARTY_AI_CONSENT_TITLE + THIRD_PARTY_AI_CONSENT_BODY
 * are all exported from `lib/effectiveslp/domain.ts`. They live there
 * because they're the canonical single-source-of-truth strings.
 */
import {
  APPLE_GUIDELINE_1_4_1_DISCLAIMER,
  HIPAA_DISCLAIMER,
  THIRD_PARTY_AI_CONSENT_BODY,
  THIRD_PARTY_AI_CONSENT_TITLE,
} from './domain';

export interface OnboardingSlide {
  key: 'welcome' | 'apple-141' | 'third-party-ai' | 'hipaa';
  eyebrow: string;
  title: string;
  body: string;
  primaryCta: string;
  /** Required for the third-party AI slide. Omitted on the others. */
  requiresAiConsentToggle?: true;
}

export const ONBOARDING_SLIDES: readonly OnboardingSlide[] = [
  {
    key: 'welcome',
    eyebrow: 'EffectiveSLP',
    title: 'Plan a session in 60 seconds',
    body:
      'EffectiveSLP turns your caseload into a session plan with ' +
      'goal-aligned activities and a parent hand-off PDF. Built for ' +
      'licensed speech-language pathologists.',
    primaryCta: 'Continue',
  },
  {
    key: 'apple-141',
    eyebrow: 'Important — please read',
    title: 'EffectiveSLP is a planning tool',
    body: APPLE_GUIDELINE_1_4_1_DISCLAIMER,
    primaryCta: 'I understand',
  },
  {
    key: 'third-party-ai',
    eyebrow: 'Third-party AI consent',
    title: THIRD_PARTY_AI_CONSENT_TITLE,
    body: THIRD_PARTY_AI_CONSENT_BODY,
    primaryCta: 'Continue',
    requiresAiConsentToggle: true,
  },
  {
    key: 'hipaa',
    eyebrow: 'HIPAA + your data',
    title: 'A note on privacy',
    body: HIPAA_DISCLAIMER,
    primaryCta: 'Continue to App',
  },
] as const;
